module.exports = __webpack_public_path__ + "static/media/bg.2b181ff0.png";